import { StaticCardTypes } from '@shared/components/cards/card-types';
import Card from '@shared/components/cards/default-cards';
import Chip from '@shared/components/chips';
import { Icon, IconNames } from '@shared/components/icons';
import { html } from '@shared/utils/rendering/html';
import { HistoryDetailItem } from './history-detail-item';
import moment from 'moment';

export const AttestationHistoryTableCollapse = ({ rowData }) => {
    const hasComments = rowData.comments && rowData.comments.trim().length > 0;

    const formattedDate = html` <span class="text-emphasis"
            >${moment(rowData.changeDate).format('DD MMM YYYY, HH:mm')}</span
        >
        <span class="text-subtle ms-1">(${moment(rowData.changeDate).fromNow()})</span>`;

    return html`
        <${Card}
            header=${{ title: 'Change Details' }}
            content=${{ type: StaticCardTypes.other }}
        >

                <div class="row">
                    <div class="col-6">
                        <${HistoryDetailItem}
                            label="Change Type"
                            value=${html`<${Chip} label=${{ text: rowData.changeType }} />`}
                        />
                    </div>
                    <div class="col-6">
                        <${HistoryDetailItem}
                            label="Modified By"
                            value=${rowData.changedBy}
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <${HistoryDetailItem}
                            label="When"
                            value=${formattedDate}
                        />
                    </div>
                    <div class="col-6">
                        <${HistoryDetailItem}
                            label="Description"
                            value=${rowData.changeDescription}
                            css="change-description"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <${HistoryDetailItem}
                            label="Comments"
                            value=${hasComments ? rowData.comments : 'No comments provided.'}
                            css="comments-section"
                        />
                    </div>
                </div>
        </${Card}>
    `;
};
